import React from "react";

const BRANDS = [
  "Angi", "Thumbtack", "HomeAdvisor", "Roto-Rooter", "Mr. Rooter",
  "Mr. Electric", "Mister Sparky", "Benjamin Franklin Plumbing",
  "ServiceMaster", "Aire Serv", "One Hour Heating & Air",
  "Five Star Painting", "Window Genie", "Neighborly", "Frontdoor",
];

const LogoMarquee = () => {
  const doubled = [...BRANDS, ...BRANDS];
  return (
    <section className="b2b-logos">
      <div className="b2b-logos-inner">
        <p className="b2b-logos-label">Driving calls to businesses across</p>
        <div className="b2b-marquee-wrapper">
          <div className="b2b-marquee-track">
            {doubled.map((name, i) => (
              <span key={i} className="b2b-logo-pill">{name}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const B2BSections = () => {
  return (
    <>
      {/* Logo marquee */}
      <LogoMarquee />

      {/* How it works */}
      <section className="b2b-features" id="how">
        <div className="b2b-features-inner">
          <div className="b2b-section-header">
            <div className="b2b-section-badge">How It Works</div>
            <h2 className="b2b-section-title">Social Intent → Live Call → Revenue</h2>
            <p className="b2b-section-desc">
              Thousands of AI agents monitor social media around the clock, find homeowners
              actively asking for contractors, and refer them — turning organic conversations
              into billable calls on pay-per-call networks.
            </p>
          </div>

          <div className="b2b-features-grid">
            <div className="b2b-feature-card">
              <div className="b2b-feature-icon">👁️</div>
              <h3 className="b2b-feature-title">24/7 Social Monitoring</h3>
              <p className="b2b-feature-desc">
                Thousands of AI agents watch Nextdoor, Facebook Groups, and other social
                platforms continuously — spotting homeowners the moment they post asking
                for a plumber, roofer, electrician, or any home service.
              </p>
            </div>

            <div className="b2b-feature-card">
              <div className="b2b-feature-icon">🤝</div>
              <h3 className="b2b-feature-title">AI Agent Referrals</h3>
              <p className="b2b-feature-desc">
                Each agent engages naturally and refers the homeowner to a relevant
                contractor — as a recommendation rather than an ad. The homeowner
                picks up the phone.
              </p>
            </div>

            <div className="b2b-feature-card">
              <div className="b2b-feature-icon">📞</div>
              <h3 className="b2b-feature-title">Pay-Per-Call Revenue</h3>
              <p className="b2b-feature-desc">
                Every completed call is monetised through pay-per-call networks. Pure
                inbound intent — no cold outreach, no ad spend — generating consistent
                revenue at over 100 calls per day.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="b2b-cta-section">
        <div className="b2b-cta-content">
          <h2 className="b2b-cta-title">Ready to scale your network?</h2>
          <p className="b2b-cta-text">
            Join the future of home services lead generation.
            100% organic intent, zero cold outreach.
          </p>
          <div className="b2b-cta-group">
            <a href="mailto:jibril@thelocalintent.company" className="b2b-cta-button b2b-cta-primary">
              Schedule a call
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default B2BSections;
